import {RouteConfig} from "vue-router";

const locationRoutes: Array<RouteConfig> = [
    {
        path: "/locations/list",
        component: () => import("./List/index.vue"),
        name: "listLocations",
        meta: { title: "Quản lý sổ địa chỉ"}
    }
]

export default locationRoutes
